let empreendimentos = [
  { 
    id: "01",
    completamenteVendido: true,
    statusDaConstrucao: "Em construção", 
    titulo: "Residencial Florença 2ª Etapa", 
    resumo: "Localizado em uma área estratégica do município, o Residencial Florença oferece lotes com infraestrutura completa de energia elétrica, rede de água, iluminação pública, galerias pluviais, além de contar com ruas com asfalto e meio-fio.", 
    descricao: "Depois do sucesso na primeira etapa, o melhor loteamento de Balsas ganhou uma nova etapa, com 355 lotes de até 255m² com a mesma infraestrutura completa da primeira etapa. As primeiras etapas das obras já estão em andamento, com ruas sendo abertas para receber meio-fio e asfalto em breve.", 
    tipoEmpreendimento: "Lotes comerciais & residenciais", 
    slug: "residencial-florenca-2-etapa", 
    lotes: 355, 
    areaLote: "255m²",
    logoEmpreendimento: "../images/api/empreendimentos/residencial-florenca-2-etapa/logo.png",
    imagemPlantaBaixa: "../images/api/empreendimentos/residencial-florenca-2-etapa/mapa.png",
    imagemDestaque: "../images/api/empreendimentos/residencial-florenca-2-etapa/destaque.jpg",  
    infraestrutura: [
      {
        icone: "../images/api/infraestruturas/redeDeAgua.png",
        titulo: "Rede de Água"
      },
      {
        icone: "../images/api/infraestruturas/energiaEletrica.png",
        titulo: "Energia Elétrica"
      },
      {
        icone: "../images/api/infraestruturas/iluminacaoPublica.png",
        titulo: "Iluminação Pública"
      },
      {
        icone: "../images/api/infraestruturas/galeriasPluviais.png",
        titulo: "Galerias Pluviais"
      },
      {
        icone: "../images/api/infraestruturas/asfaltoEMeioFio.png",
        titulo: "Asfalto e Meio-fio"
      }
    ], 
    galeria: [
      { imagem: "../images/api/empreendimentos/residencial-florenca-2-etapa/galeria/foto1.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-2-etapa/galeria/foto2.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-2-etapa/galeria/foto3.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-2-etapa/galeria/foto4.JPG" }, 
    ], 
    localizacao: { 
      latitude: -7.534374900000001, 
      longitude: -46.07219060000001 
    } 
  }, 
  { 
    id: "02",
    completamenteVendido: true,
    statusDaConstrucao: "Em construção", 
    titulo: "Residencial Florença 1ª Etapa", 
    resumo: "Localizado em uma área estratégica do município, o Residencial Florença oferece lotes com infraestrutura completa de energia elétrica, rede de água, iluminação pública, galerias pluviais, além de contar com ruas com asfalto e meio-fio.", 
    descricao: "O primeiro loteamento a gente nunca esquece. E o Florença Primeira Etapa marcou o início de uma nova fase da história da Cromo e de Balsas. São 742 lotes de ate 255m², com infraestrutura completa para você construir sua casa ou ponto comercial. As obras estão avançando, com ruas já abertas e recebendo asfalto e perfuração de poços.", 
    tipoEmpreendimento: "Lotes comerciais & residenciais", 
    slug: "residencial-florenca-1-etapa", 
    lotes: 742, 
    areaLote: "255m²",
    logoEmpreendimento: "../images/api/empreendimentos/residencial-florenca-1-etapa/logo.png",
    imagemPlantaBaixa: "../images/api/empreendimentos/residencial-florenca-1-etapa/mapa.png",
    imagemDestaque: "../images/api/empreendimentos/residencial-florenca-1-etapa/destaque.jpg", 
    infraestrutura: [
      {
        icone: "../images/api/infraestruturas/redeDeAgua.png",
        titulo: "Rede de Água"
      },
      {
        icone: "../images/api/infraestruturas/energiaEletrica.png",
        titulo: "Energia Elétrica"
      },
      {
        icone: "../images/api/infraestruturas/iluminacaoPublica.png",
        titulo: "Iluminação Pública"
      },
      {
        icone: "../images/api/infraestruturas/galeriasPluviais.png",
        titulo: "Galerias Pluviais"
      },
      {
        icone: "../images/api/infraestruturas/asfaltoEMeioFio.png",
        titulo: "Asfalto e Meio-fio"
      }
    ], 
    galeria: [
      { imagem: "../images/api/empreendimentos/residencial-florenca-1-etapa/galeria/foto1.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-1-etapa/galeria/foto2.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-1-etapa/galeria/foto3.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-1-etapa/galeria/foto4.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-1-etapa/galeria/foto5.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-1-etapa/galeria/foto6.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-1-etapa/galeria/foto7.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-1-etapa/galeria/foto8.JPG" },
      { imagem: "../images/api/empreendimentos/residencial-florenca-1-etapa/galeria/foto9.JPG" },
    ], 
    localizacao: { 
      latitude: -7.534374900000001, 
      longitude: -46.07219060000001 
    } 
  },
  {
    id: "03",
    completamenteVendido: false,
    statusDaConstrucao: "Obra entregue",
      titulo: "Residencial Veneza",
    resumo: "Lorem ipsum libero litora mollis quisque a erat, vulputate fames elementum fames interdum volutpat at quisque, pretium mauris class curabitur congue curabitur.vestibulum nullam viverra volutpat morbi euismod eget mi, ut duis at quis euismod.",
    descricao: "Lorem ipsum malesuada blandit purus nullam consequat donec phasellus, ut auctor fames ultricies integer hendrerit aptent vehicula, proin hendrerit iaculis sed ad varius ad. per conubia phasellus primis etiam molestie dictumst euismod aptent euismod, nullam blandit sollicitudin accumsan eros platea in tincidunt, condimentum ornare feugiat pretium libero maecenas euismod diam.",
    tipoEmpreendimento: "Lotes comerciais & residenciais",
    slug: "residencial-veneza",
    lotes: 100,
    areaLote: "200m²",
    logoEmpreendimento: "../images/api/empreendimentos/residencial-veneza/logo.png",
    imagemPlantaBaixa: "../images/api/empreendimentos/residencial-veneza/mapa.png",
    imagemDestaque: "../images/api/empreendimentos/residencial-veneza/destaque.png",
    infraestrutura: [
      {
        icone: "../images/api/infraestruturas/redeDeAgua.png",
        titulo: "Rede de Água"
      },
      {
        icone: "../images/api/infraestruturas/energiaEletrica.png",
        titulo: "Energia Elétrica"
      },
      {
        icone: "../images/api/infraestruturas/iluminacaoPublica.png",
        titulo: "Iluminação Pública"
      },
      {
        icone: "../images/api/infraestruturas/galeriasPluviais.png",
        titulo: "Galerias Pluviais"
      },
      {
        icone: "../images/api/infraestruturas/asfaltoEMeioFio.png",
        titulo: "Asfalto e Meio-fio"
      }
    ],
    galeria: [],
    localizacao: {
      latitude: -7.534374900000001,
      longitude: -46.07219060000001
    }
  },
];

export default empreendimentos;